/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslationsContext } from '../../context/TranslationsContext';

import { ActionButton } from './css';
import { getLocalFormattedTime } from '../../salesRepDashboard/utils';
import { getDeviceName } from './utils';
import { fieldSubscriberDetailsDevicePlan } from '../../utils/constant';

const SubscribersList = ({
  subscriberDetails,
  updateOrder,
  setEditingSubscriber,
  editingSubscriber,
  currentSubscriber,
  totalSubscribers,
  setShowErrorSubscriber
}) => {
  const {
    WLS: {
      SUBSCRIBERS_LIST: {
        subscribersList,
        Name,
        Device,
        RatePlan,
        CreationDate,
        Actions,
        Edit,
        Delete
      },
      SUBSCRIBER_DETAILS: { Accessories }
    }
  } = useTranslationsContext();
  const deleteSubscriber = id => {
    const updatedSubscriberDetails = subscriberDetails.filter(
      subscriberDetail => subscriberDetail.id !== id
    );
    updateOrder({ subscriberDetails: updatedSubscriberDetails }, 'REMOVE');
  };
  return (
    <div style={{ marginTop: '3rem', marginBottom: '4.5rem' }}>
      <div
        style={{
          padding: '0.75rem',
          background: '#4b286d',
          color: '#fff',
          fontWeight: '700'
        }}
      >
        {subscribersList}
      </div>
      <table className="table table-bordered">
        <thead style={{ background: '#efefef' }}>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{Name}</th>
            <th scope="col">{Device}</th>
            <th scope="col">{RatePlan}</th>
            <th scope="col">{CreationDate}</th>
            <th scope="col">{Actions}</th>
          </tr>
        </thead>
        <tbody>
          {subscriberDetails.map((subscriberDetail, index) => {
            const isAccessoriesOnly =
              subscriberDetail[fieldSubscriberDetailsDevicePlan] ===
              Accessories;
            const valueContractTerm = _.get(
              subscriberDetail,
              'subscriberDetailsContractTerm',
              ''
            );
            const getDeviceModel = _.get(
              subscriberDetail,
              'subscriberDetailsDeviceModel',
              ''
            );
            const subscriberId = _.get(subscriberDetail, 'id', '');
            const subscriberName = `${_.get(
              subscriberDetail,
              'subscriberDetailsFirstName',
              ''
            )} ${_.get(subscriberDetail, 'subscriberDetailsLastName', '')}`;
            const subscriberDevice = getDeviceName(
              _.get(subscriberDetail, 'subscriberDetailsDevices', '')
            );
            const subscriberRatePlan = _.get(
              subscriberDetail,
              'subscriberDetailsRateplanName',
              ''
            );
            const subscriberCreatedAt = _.get(
              subscriberDetail,
              'createdAt',
              ''
            );
            if (
              !editingSubscriber ||
              (editingSubscriber && editingSubscriber !== subscriberId)
            )
              return (
                <tr>
                  <th scope="row">{index + 1}</th>
                  <td>{subscriberName}</td>
                  {isAccessoriesOnly ? (
                    <td>{Accessories}</td>
                  ) : valueContractTerm === '3 Year' ||
                    valueContractTerm === '3 Ans' ? (
                    <td>{getDeviceModel}</td>
                  ) : (
                    <td>{subscriberDevice}</td>
                  )}
                  <td>{subscriberRatePlan}</td>
                  <td>{getLocalFormattedTime(subscriberCreatedAt)}</td>
                  {!editingSubscriber && (
                    <td>
                      <ActionButton
                        onClick={() => {
                          setEditingSubscriber(subscriberId);
                          setShowErrorSubscriber(false);
                        }}
                      >
                        {Edit}
                      </ActionButton>
                      <span style={{ margin: '0 0.5rem', color: '#4b286d' }}>
                        |
                      </span>
                      <ActionButton
                        onClick={() => deleteSubscriber(subscriberId)}
                      >
                        {Delete}
                      </ActionButton>
                    </td>
                  )}
                </tr>
              );
            return null;
          })}
        </tbody>
      </table>
    </div>
  );
};

SubscribersList.propTypes = {
  subscriberDetails: PropTypes.arrayOf(PropTypes.any).isRequired,
  updateOrder: PropTypes.func.isRequired,
  setEditingSubscriber: PropTypes.func.isRequired,
  editingSubscriber: PropTypes.string.isRequired,
  currentSubscriber: PropTypes.number.isRequired,
  totalSubscribers: PropTypes.number.isRequired,
  setShowErrorSubscriber: PropTypes.func.isRequired
};

export default SubscribersList;
